import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

// COMPONENTS
import PipeProvider from 'Services/Providers/PipeProvider';
import CartDrawer from 'components/Cart/CartDrawer/CartDrawer';
import HeaderDesktop from './HeaderDesktop/HeaderDesktop';
import HeaderMobile from './HeaderMobile/HeaderMobile';

// STYLES
import 'Assets/styles/default/components/Header/HeaderStyles.less';
import { useSelector } from 'react-redux';
import HeaderPlaceholder from './HeaderPlaceholder';
import SimulationIndicator from 'pages/newSolicitation/components/SimulationIndicator';
import { addDimensionsGTM } from 'Shared/dataLayer/dataLayer';
import { useSimulationLocalStorageContext } from 'Context/SimulationLocalSotrageContext';
import { VertTokens } from '@vertem-core/vertice-ds';

// COMMON PROPS
const commonPropTypes = {
  headerParams: PropTypes.shape({
    headerLogo: PropTypes.string,
    userName: PropTypes.string,
    userPoints: PropTypes.string,
    notificationsItems: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string,
      })
    ),
    cartItems: PropTypes.shape({
      products: PropTypes.array,
      summary: PropTypes.object,
    }),
  }),
  isLoading: PropTypes.bool,
};

/* eslint-disable */
// HEADER COMPONENT
const HeaderDefault = () => {
  /* States */
  const [isSendGTM, setSendGTM] = useState(false);
  const [isOpenCartDrawer, setIsOpenCartDrawer] = useState(false);

  const itemsCartReducer = useSelector(({ Cart: data }) => data);
  const { cart } = itemsCartReducer;
  const cartItems = cart?.items || [];
  const { simulationLocalStorageValue } = useSimulationLocalStorageContext();

  const userProfile = useSelector((state) => state.oidc.user?.profile);

  /* Handlers */
  const searchButtonHandler = (event) => {
    const { value } = event.currentTarget;
    console.log('INPUT VALUE ==>', value || '');
  };

  const openCloseCartDrawerHandler = () => {
    setIsOpenCartDrawer(!isOpenCartDrawer);
  };

  useEffect(() => {
    if (userProfile && userProfile['custom:catalog_id'] && !isSendGTM) {
      addDimensionsGTM(userProfile);
      setSendGTM(true);
    }
  }, [userProfile && !isSendGTM]);

  const { designTokens } = useContext(VertTokens);
  const { logotipo: Logotipo } = designTokens;

  /* Renders */
  return (
    <PipeProvider
      apiSymbols={['FETCH_CART']}
      loadingComponent={<HeaderPlaceholder />}
    >
      <>
        {!!simulationLocalStorageValue &&
          !!simulationLocalStorageValue?.enabled && <SimulationIndicator />}
        {/* Mobile Version */}
        <MediaQuery maxWidth={1024}>
          <HeaderMobile
            logo={Logotipo}
            openCloseCartDrawerHandler={openCloseCartDrawerHandler}
            searchButtonHandler={searchButtonHandler}
            quantityItemsCart={cartItems.length}
          />
        </MediaQuery>

        {/* Desktop Version */}
        <MediaQuery minWidth={1025}>
          <HeaderDesktop
            logo={Logotipo}
            openCloseCartDrawerHandler={openCloseCartDrawerHandler}
            searchButtonHandler={searchButtonHandler}
            quantityItemsCart={cartItems.length}
          />
        </MediaQuery>

        {isOpenCartDrawer && (
          <CartDrawer
            isOpen={isOpenCartDrawer}
            openCloseHandler={openCloseCartDrawerHandler}
          />
        )}
      </>
    </PipeProvider>
  );
};
HeaderDefault.propTypes = {
  ...commonPropTypes,
};
export default HeaderDefault;
